// Auto generated by ControleTool.ModelClassGenerator
import { inject } from 'aurelia-framework';
import { ValidationRules } from 'aurelia-validation';
import { Helpers } from '../services/helpers';
import { SubAssignmentIndexViewModel } from './subassignmentindexview-model';
import { EOLStoredDataViewModel } from './eolstoreddataview-model';
import { AnswerSelectedFieldViewModel } from './answerselectedfieldview-model';
import { AnswerSelectedFilterViewModel } from './answerselectedfilterview-model';


export class AnswerViewModel {
    id: number = 0;
	isXMLCall: boolean = false;
	uri: string = null;
	entity: string = null;
	subAssignmentId: number = 0;
	subAssignment: SubAssignmentIndexViewModel = null;
	answerText: string = null;
	answerDescription: string = null;
	importance: number = 1;
	order: number = 0;
	studentIncorrectMessage: string = null;
	teacherIncorrectMessage: string = null;
	eolStoredDataId: number = 0;
	eolStoredData: EOLStoredDataViewModel = null;
	answerSelectedFields: AnswerSelectedFieldViewModel[] = null;
	answerSelectedFilters: AnswerSelectedFilterViewModel[] = null;
	createdOn: Date = new Date();
	modifiedOn: Date | null = null;
	lastModifiedDate: Date = new Date();
	
	constructor(data: any = null) {
        
		if (data) {
			Helpers.mapProperties(data, this);
        }
        
	}
}